import { apiInstance } from "../config/apiInstance";

export const getUsers = async()=> {
  const response = await apiInstance.get("v1/users/page");

  return response.data;
}
